import { render, staticRenderFns } from "./VerticalNavMenuFooter.vue?vue&type=template&id=6f906e5c&"
import script from "./VerticalNavMenuFooter.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenuFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports